import React, { useState } from 'react';
import PropTypes from "prop-types";
import classNames from "classnames";

interface CheckboxWidgetProps {
    label?: React.ReactNode;
    isChecked?: boolean;
    onValueChange?: (value: boolean) => void;
    className?: string;
}

const propTypes = {
    isChecked: PropTypes.bool,
    label: PropTypes.node,
    onValueChange: PropTypes.func
}

const defaultProps = {
    isChecked: false,
    label: '',
    onValueChange: ()=>{}
}

const CheckboxWidget = ({
    label,
    isChecked,
    onValueChange,
    className,
}: CheckboxWidgetProps) => {
    const [checked, setChecked] = useState(isChecked);

    const handleCheckboxChange = () => {
        setChecked(!checked);
        onValueChange?.(!checked)
    };

    const classes = classNames(
        'd-flex',
        'align-items-center',
        className
    )

    return (
        <label className={classes}>
            <input
                type="checkbox"
                checked={checked}
                onChange={handleCheckboxChange}
            />
            <span className="mx-2 font-xs">{label}</span>
        </label>
    );
};

CheckboxWidget.propTypes = propTypes;
CheckboxWidget.defaultProps = defaultProps;

export default CheckboxWidget;
